import React, { useReducer, useState, useContext } from "react";
import axios from "axios";
import PaymentContext from "./PaymentContext";
import PaymentReducer from "./PaymentReducer";
import {
  GET_PAYMENTS,
  SET_LOADING,
  GET_PAYMENTS_ERROR,
  GET_PAYMENT,
  GET_PAYMENT_ERROR,
  GET_UNMATCHED,
  GET_DETAILS,
  GET_DETAILS_ERROR,
  EDIT_CUSTOMER_INFO,
  PAYMENT_ORDER_POSTING,
  PAYMENT_ACTION_ERROR,
} from "../../types";
import AuthContext from "../../auth/AuthContext";

const PaymentState = (props) => {
  const initialState = {
    payments: null,
    payments_unmatched: null,
    returned_info: null,
    returned_posting: null,
    payment: null,
    details: null,
    error: null,
    loading: false,
  };

  const [state, dispatch] = useReducer(PaymentReducer, initialState);
  const [searchedDate, setSearchedDate] = useState([]);
  const { user } = useContext(AuthContext);

  // Set Loading
  const setLoading = () =>
    dispatch({
      type: SET_LOADING,
    });

  // Get latest data from PaypalPayments
  const getPayments = async (from, to) => {
    setLoading(true);
    const existedDateRange = [];
    for (let x in searchedDate) {
      existedDateRange.push(
        searchedDate[x]["dateFrom"] + " " + searchedDate[x]["dateTo"]
      );
      if (
        from === searchedDate[x]["dateFrom"] &&
        to === searchedDate[x]["dateTo"]
      ) {
        dispatch({
          type: GET_PAYMENTS,
          payload: searchedDate[x]["data"],
        });
      }
    }
    if (existedDateRange.indexOf(from + " " + to) < 0) {
      try {
        const res = await axios.post("/api/paypal/payments/v1/get-payments", {
          dateFrom: from,
          dateTo: to,
        });
        dispatch({
          type: GET_PAYMENTS,
          payload: res.data,
        });
        // If date to is today, dont save into State / Context
        const todayISODate = new Date(
          new Date().setHours(24, 0, 0, 0)
        ).toISOString();
        if (to !== todayISODate) {
          setSearchedDate((searchedDate) => [
            ...searchedDate,
            {
              dateFrom: from,
              dateTo: to,
              data: res.data,
            },
          ]);
        }
      } catch (err) {
        dispatch({
          type: GET_PAYMENTS_ERROR,
          payload: err.response,
        });
      }
    }
  };

  // Get latest data from PaypalPayments
  const getDetails = async (payment_id, payment_type) => {
    setLoading(true);
    try {
      const res = await axios.post("/api/paypal/payments/v1/get-details", {
        payment_id: payment_id,
        payment_type: payment_type,
      });
      dispatch({
        type: GET_DETAILS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: GET_DETAILS_ERROR,
        payload: err.response,
      });
    }
  };

  // Get latest data from PaypalPayments
  const getPaymentByID = async (id) => {
    setLoading(true);
    try {
      const res = await axios.post("/api/paypal/payments/v1/get-payments", {
        id: id,
      });
      dispatch({
        type: GET_PAYMENT,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: GET_PAYMENT_ERROR,
        payload: err.response,
      });
    }
  };

  const getUnmatched = (checked) => {
    dispatch({
      type: GET_UNMATCHED,
      payload: checked,
    });
  };

  // Edit Customer Information
  const editCustomerInfo = async (email, transaction_id) => {
    setLoading(true);
    try {
      const res = await axios.post(
        "/api/paypal/payments/v1/edit-customer-info",
        {
          email: email,
          transaction_id: transaction_id,
          username: user.name,
        }
      );

      dispatch({
        type: EDIT_CUSTOMER_INFO,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: PAYMENT_ACTION_ERROR,
        payload: err.response,
      });
    }
  };

  // Shopify Order Posting
  const postOrder = async (express_token, transaction_id) => {
    setLoading(true);
    try {
      const res = await axios.post(
        "https://www.trackpaypro.com/api/v1/paypal/paypal-shopify-create-order",
        {
          express_token: express_token,
        }
      );

      // Create Logs
      // Format UTC Date
      const nDate = new Date();
      nDate.setHours(nDate.getHours() + 8);
      const dDate = nDate.toISOString().replace(/T/, " ").replace(/\..+/, "");
      await axios.post("/api/logs/", {
        user: user.name,
        action: "order-posting",
        description: `paypal payment - post order for (transaction ID : ${transaction_id})`,
        created_at: dDate,
      });

      dispatch({
        type: PAYMENT_ORDER_POSTING,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: PAYMENT_ACTION_ERROR,
        payload: err.response,
      });
    }
  };

  return (
    <PaymentContext.Provider
      value={{
        payments: state.payments,
        payment: state.payment,
        details: state.details,
        returned_info: state.returned_info,
        returned_posting: state.returned_posting,
        error: state.error,
        payments_unmatched: state.payments_unmatched,
        loading: state.loading,
        getPayments,
        setLoading,
        getUnmatched,
        getPaymentByID,
        getDetails,
        editCustomerInfo,
        postOrder,
      }}
    >
      {props.children}{" "}
    </PaymentContext.Provider>
  );
};

export default PaymentState;
